<template>
  <el-col :sm="12">
    <div class="wrapper">
      <div class="header">
        <h2 class="">Yhteyshenkilöt</h2>
      </div>
      <div v-if="contactsByDistrict.length > 0">
        <div v-for="contact in contactsByDistrict">
          <contact :contact="contact" :changedValues.sync="changedValues[contact.id]"></contact>
        </div>
      </div>
      <el-button class="add" type="primary" icon="plus" @click="addContact"></el-button>
    </div>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Contact from './Contact.vue';


  export default {
    components: { Contact },

    data() {
      return {
        changedValues: {}
      }
    },

    computed: mapGetters(['contactsByDistrict']),

    methods: {
      addContact() {
        this.$store.commit('increment');
        const data = {
          values: {
            district: this.$store.getters.district,
            email: '',
            name: '',
            title: '',
            id: this.$store.getters.count,
            isNew: true,
          },
          type: 'contacts',
        };
        this.$store.dispatch('addData', data);
      },
    },

  }
</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    .add {
      position: absolute;
      bottom: -17px;
      z-index: 100;
      left: calc(50% - 23px);
    }
  }
  .header {
    margin-bottom: 20px;
    > * {
      display: inline-block;
      vertical-align: middle;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Contacts.vue?7a1b61ce